// extracted by mini-css-extract-plugin
export default {"color-selector":"color-selector__Fxy8f","colorSelector":"color-selector__Fxy8f","box":"box__x5cMk","selected":"selected__5ga09"};